<template>
  <div>
    <div class="d-flex align-items-start justify-content-between flex-wrap bg-white p-1 rounded">
      <apexchart
        class="responsive-chart"
        height="450"
        :options="computedChartOptions"
        :series="dataSeries"
      />
      <div
        class="d-flex flex-column align-items-center justify-content-end flex-column custom-direction"
      >
        <info-card
          v-for="item in infoCard"
          :key="item.id"
          class="mt-1"
          :elipse-color="item.elipseColor"
          :title="item.title"
          :description="item.description"
          :loading="item.loading"
        />
      </div>
    </div>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import InfoCard from '@/components/analytics/components/InfoCard.vue'

export default {
  components: {
    apexchart: VueApexCharts,
    InfoCard,
  },
  props: {
    infoCard: {
      type: Array,
      default: () => ([]),
      required: true,
    },
    dataSeries: {
      type: [Array, Object],
      default: () => ([]),
    },
    customCachedDataName: {
      type: String,
      default: '',
    },
    customNonCachedDataName: {
      type: String,
      default: '',
    },
    timeStamps: {
      type: [Array, Object],
      default: () => ([]),
    },
    formatPercentage: {
      default: false,
      type: Boolean,
    },
  },
  computed: {
    timeSeriesFormatted() {
      return this.timeStamps || []
    },
    computedChartOptions() {
      const chartOptions = {
        chart: {
          type: 'bar',
          zoom: {
            enabled: false,
          },
          fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif',
        },
        fill: {
          opacity: 1,
          gradient: {
            opacityFrom: 0.8,
            opacityTo: 0.6,
          },
        },
        dataLabels: {
          enabled: false,
        },
        legend: {
          show: false,
        },
        yaxis: {
          labels: {
            formatter: value => value.toLocaleString(),
          },
        },
        xaxis: {
          tickAmount: 7,
          categories: this.timeSeriesFormatted,
          tooltip: {
            enabled: false,
          },
          labels: {
            formatter: value => `${this.timeSince(value, true)} ago`,
          },
        },
        noData: {
          text: 'Data Unavailable: Currently, no data is being returned.',
          align: 'center',
          verticalAlign: 'middle',
          offsetX: 0,
          offsetY: -15,
          style: {
            color: '#7483A1',
            fontSize: '14px',
            fontFamily: undefined,
          },
        },
        tooltip: {
          shared: true,
          intersect: false,
          y: {
            formatter: value => `${value.toLocaleString()}`,
          },
          x: {
            formatter: value => `${this.unixTimestampToDateTime(value)}`,
          },
        },
        stroke: {
          curve: 'smooth',
        },
        colors: ['#619AF8', '#F2A342'],
      }
      return chartOptions
    },
  },
}
</script>
<style scoped>

 .responsive-chart {
   width: 90%; /* Chart will take 100% width on all screen sizes */
 }

 @media (min-width: 220px) {
  .responsive-chart {
      width: 100%; /* Adjust the height for larger screens (e.g., tablets) */
   }
   .custom-direction{
    flex-direction: row !important;
    justify-content: start !important;
    flex-wrap: wrap;
    gap: 4px;
   }

   .custom-margin{
    margin-top: 0px !important;
    margin-right: 3px !important;
   }

 }

 @media (min-width: 992px) {
   .responsive-chart {
      width: 70%; /* Adjust the height for larger screens (e.g., tablets) */
   }

   .custom-margin {
    margin-top: 5px !important;
   }
   .custom-direction{
    flex-direction: column !important;
   }

 }

 @media (min-width: 1200px) {
   .responsive-chart {
    width: 75%; /* Adjust the height for even larger screens (e.g., desktops) */
   }
 }

 @media (min-width: 1600px) {
   .responsive-chart {
    width: 85%; /* Adjust the height for even larger screens (e.g., desktops) */
   }
 }
</style>
